import _ from 'lodash';
import { connect } from 'react-redux';
import { createToolbarEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { leaveConference } from '../../base/conference/actions';
import { translate } from '../../base/i18n/functions';
import AbstractHangupButton from '../../base/toolbox/components/AbstractHangupButton';
import { LEAVE_CALL_LABEL } from '../../interpreter-queue/groupEndForAll';
import { END_CALL_LABEL } from '../../interpreter-queue/vriSessionHangup';
/**
 * The red hang-up of a VRI session's room, web and native
 * (interpreter-queue/vriSessionHangup.ts). It hangs up like every hang-up
 * (leaveConference decides what that does in a `vri-` room); only its words
 * differ, so that they say what happens: Jitsi's "Leave the meeting" ended
 * the session for everyone.
 */
class VriHangupButtonBase extends AbstractHangupButton {
    /**
     * Initializes a new instance.
     *
     * @param {AbstractButtonProps} props - The read-only properties.
     */
    constructor(props) {
        super(props);
        this._hangup = _.once(() => {
            sendAnalytics(createToolbarEvent('hangup'));
            this.props.dispatch(leaveConference());
        });
    }
    /**
     * Hangs up.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _doHangup() {
        this._hangup();
    }
}
/** The client who started the session: it ends for everyone. */
class EndCallButton extends VriHangupButtonBase {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = END_CALL_LABEL;
        this.label = END_CALL_LABEL;
        this.tooltip = END_CALL_LABEL;
    }
}
/** Everyone else: the interpreter, the guests and any other account. */
class LeaveCallButton extends VriHangupButtonBase {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = LEAVE_CALL_LABEL;
        this.label = LEAVE_CALL_LABEL;
        this.tooltip = LEAVE_CALL_LABEL;
    }
}
export const VriEndCallButton = translate(connect()(EndCallButton));
export const VriLeaveCallButton = translate(connect()(LeaveCallButton));
